import { myConst, myMap } from "@/config/";
import { mapData, findAndPin } from "../initMap";
import { toggleInfoBox } from "@/components/Map/utils/infoBox";
import rootStore from "@/store/";
const { appStore, dataStore, mapStore } = rootStore;


export const initEvent = function () {
    // 注册事件
    // console.log('mEvent', _this.myConst.mEvent)

    // myMap.map.addEventListener('longpress', (event) => {
    //     console.log('我长按了地图');
    // });

    // 调整浏览器窗口大小事件
    myMap.map.addEventListener('resize', () => {
        myMap.map.centerAndZoom(myMap.map.getCenter(), myMap.map.getZoom());
    });

    // 计算每次移动地图后的中心点
    myMap.map.addEventListener('moveend', event => {
        const centerPoint = myMap.map.getCenter();
        const lastDistance = myMap.map.getDistance(mapData.lastCenterLoc, centerPoint);
        console.blue('moveend lastDistance', myConst.minPinDis, lastDistance);
        mapData.lastCenterLoc = centerPoint;
        // 如果移动范围大于 "minPinDis" 重新 pin
        if (lastDistance >= myConst.minPinDis) {
            findAndPin(centerPoint);
        }
    });
    // 开始缩放地图
    myMap.map.addEventListener('zoomend', event => {
        toggleInfoBox({ source: 'zoomend map', on_off: false });
        const zoomLevel = myMap.map.getZoom();
        if (zoomLevel >= myConst.HIDE_MARKER_TEXT_LEVEL) {
            mapStore.changeHideMarkerText(false);
        } else {
            mapStore.changeHideMarkerText(true);
        }
        myMap.map.dispatchEvent("moveend");
    });

    myMap.map.addEventListener('touchstart', event => {
        if (!myMap.map._myTouchEvent) myMap.map._myTouchEvent = {};
        myMap.map._myTouchEvent.tStart = event.pixel;
        // 左侧滑动拉出
        // _this.myVar.appTouch.tStart = event.pixel;
    });
    // click touchend
    myMap.map.addEventListener(myConst.mEvent, event => {
        //如果点击的地方有覆盖物
        if (event.overlay) {
            if (event.overlay.getLabel(".marker_icon")) { // getLabel 无参数 此处参数仅为注释用
                const labelContent = event.overlay.getLabel().getContent();
                const _domId = labelContent.match(/markerId_.+_markerId/);
                if (!_domId) return;
                const labelDom = document.getElementById(_domId[0]);
                if (labelDom) {
                    // 找到单车点 ID - OBJ
                    if (!labelDom._markerInfo) {
                        // 缓存到 dom 上，下次不用再找
                        const vId = labelDom.id.replace('markerId_', '').replace('_markerId', '');
                        const dataList = dataStore.dataList;
                        const findItem = dataList.find(item => item.id === vId);
                        if (findItem) labelDom._markerInfo = findItem;
                    }
                    toggleInfoBox({ on_off: true, detail: { v: labelDom._markerInfo } });
                }
            }
        } else {
            // 判断单击
            mapData.singleTap++;
            clearTimeout(mapData.mapClickEventTimer);
            mapData.mapClickEventTimer = setTimeout(() => {
                if (mapData.singleTap === 1) {
                    mapData.singleTap = 0;
                    if (myConst.isMobile) {
                        let tPoint = myMap.map._myTouchEvent;
                        tPoint.tEnd = event.pixel;
                        if (Math.abs(tPoint.tEnd.x - tPoint.tStart.x) < 10 && Math.abs(tPoint.tEnd.y - tPoint.tStart.y) < 10) {
                            // 点击事件
                            mapClose();
                        } else {
                            // 滑动事件
                        }
                    } else {
                        mapClose();
                    }
                } else {
                    mapData.singleTap = 0;
                }
            }, 300);
        }

        function mapClose() {
            if (appStore.appState.searchShow) {
                //
                // 如果有 searchShow -> 关
                //             |-> infoBox ->关
                //                    |-> 神马都没有 -> 全屏
                // searchShow
                appStore.toggleSearchShow(false);
            } else {
                if (myMap.infoBox._isOpen) {
                    // infoBox
                    toggleInfoBox({ source: 'mapClose', on_off: false });
                } else {
                    // 全屏
                    // if (myConst.isMobile && navigator.userAgent.indexOf('UCBrowser') == -1) {
                    //     UTILS.toggleFullScreen();
                    //     if (!document.fullscreenElement && // alternative standard method
                    //         !document.mozFullScreenElement && !document.webkitFullscreenElement && !document.msFullscreenElement) { // current working methods
                    //         $$("#map .BMap_noprint.anchorTR").removeClass('hide');
                    //         $$("#map .BMap_stdMpCtrl.BMap_noprint.anchorBR").removeClass('hide');
                    //         $$("#iLoc").removeClass('hide');
                    //         $$("#floatBtn").removeClass('mdui-fab-hide');
                    //     } else {
                    //         $$("#map .BMap_noprint.anchorTR").addClass('hide');
                    //         $$("#map .BMap_stdMpCtrl.BMap_noprint.anchorBR").addClass('hide');
                    //         $$("#iLoc").addClass('hide');
                    //         $$("#floatBtn").addClass('mdui-fab-hide');
                    //     }
                    // }
                }
            }
        }
    });
};
